import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes (for less critical data)
        gcTime: 10 * 60 * 1000, // 10 minutes
        retry: (failureCount, error) => {
          // Don't retry on 4xx errors
          if (error && typeof error === 'object' && 'errorCode' in error) {
            const apiError = error as { errorCode: string };
            if (apiError.errorCode.startsWith('4')) {
              return false;
            }
          }
          return failureCount < 3;
        },
        refetchOnWindowFocus: true, // Changed to true for better freshness
        refetchOnMount: true,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false,
      },
    },
  });
};

// Query keys factory
export const queryKeys = {
  // Auth
  auth: ['auth'] as const,
  currentUser: () => [...queryKeys.auth, 'currentUser'] as const,

  // Divisions
  divisions: ['divisions'] as const,
  division: (id: string) => [...queryKeys.divisions, id] as const,
  divisionUsers: (id: string) => [...queryKeys.divisions, id, 'users'] as const,

  // Users
  users: ['users'] as const,
  user: (id: string) => [...queryKeys.users, id] as const,
  usersByDivision: (divisionId: string) => [...queryKeys.users, 'division', divisionId] as const,

  // Orders
  orders: ['orders'] as const,
  order: (id: string) => [...queryKeys.orders, id] as const,
  ordersByDivision: (divisionId: string) => [...queryKeys.orders, 'division', divisionId] as const,
  ordersByUser: (userId: string, filters?: any) => 
    [...queryKeys.orders, 'user', userId, ...(filters ? [filters] : [])] as const,
  pendingApprovals: (userId: string) => 
    [...queryKeys.orders, 'pending-approvals', userId] as const,
};
